module.exports = __webpack_public_path__ + "static/media/weixin.5a0555d2.svg";